import { Dialog } from '@progress/kendo-react-dialogs';
import { BackActionDialogContentLayout } from 'app/components/layouts';
import MapLegendEquipment from 'assets/images/ill_map_legend_equipment.png';
import MapLegendEquipmentError from 'assets/images/ill_map_legend_equipment_error.png';
import MapLegendEquipmentOut from 'assets/images/ill_map_legend_equipment_out.png';
import MapLegendEquipmentOutError from 'assets/images/ill_map_legend_equipment_out_error.png';
import MapLegendEv from 'assets/images/ill_map_legend_ev.png';
import MapLegendPaired from 'assets/images/ill_map_legend_paired.png';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@progress/kendo-react-buttons';
import './LegendDialog.less';
interface Props {
  open: boolean;
  onClose: () => void;
}

export function LegendDialog({ open, onClose }: Props) {
  const { t } = useTranslation();

  if (!open) {
    return null;
  }

  return (
    <Dialog className="modal-form">
      <BackActionDialogContentLayout onBack={onClose} className="legend-dialog">
        <h2 className="legend-dialog__title">{t('map_legend_title')}</h2>
        <p className="legend-dialog__subtitle">{t('map_legend_subtitle')}</p>

        <div className="legend-dialog__list">
          <div className="legend-dialog__item">
            <img src={MapLegendEquipment} alt="Not found" />
            <span
              dangerouslySetInnerHTML={{
                __html: t('map_legend_equipment'),
              }}
            />
          </div>
          <div className="legend-dialog__item">
            <img src={MapLegendEquipmentError} alt="Not found" />
            <span
              dangerouslySetInnerHTML={{
                __html: t('map_legend_equipment_error'),
              }}
            />
          </div>
          <div className="legend-dialog__item">
            <img src={MapLegendEquipmentOut} alt="Not found" />
            <span
              dangerouslySetInnerHTML={{
                __html: t('map_legend_equipment_out'),
              }}
            />
          </div>
          <div className="legend-dialog__item">
            <img src={MapLegendEquipmentOutError} alt="Not found" />
            <span
              dangerouslySetInnerHTML={{
                __html: t('map_legend_equipment_error_out'),
              }}
            />
          </div>
          <div className="legend-dialog__item">
            <img src={MapLegendPaired} alt="Not found" />
            <span
              dangerouslySetInnerHTML={{
                __html: t('map_legend_equipment_paired'),
              }}
            />
          </div>
          <div className="legend-dialog__item">
            <img src={MapLegendEv} alt="Not found" />
            <span
              dangerouslySetInnerHTML={{
                __html: t('map_legend_ev'),
              }}
            />
          </div>
        </div>

        <Button themeColor="primary" onClick={onClose}>
          {t('ok')}
        </Button>
      </BackActionDialogContentLayout>
    </Dialog>
  );
}
